import { computed, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Coordinate } from "@app/_models/coordinate";
import { AddressDto } from "@dtos/address-dto/address-dto";
import { MessageBusService } from "@services/message-bus.service";
import { ProfileService } from "@services/profile.service";

@Injectable({
    providedIn: 'root'
})
export class AddressService {
    private _profileService = inject(ProfileService);
    private _messageBus = inject(MessageBusService);
    private _profile = this._profileService.customerProfile.asReadonly();

    registeredAddresses = computed(() => this._profile()?.addresses ?? []);
    selectedAddress = signal<AddressDto | undefined>(undefined);
    isValidAddress = computed(() => this.selectedAddress() && this._isValidAddress(this.selectedAddress()));
    hasLocation = computed(() => this.selectedAddress() && this.selectedAddress().lat !== 0 && this.selectedAddress().lng !== 0);

    constructor() {
        this._messageBus.onOrderAccepted
            .pipe(takeUntilDestroyed())
            .subscribe(accepted => {
                if (!accepted) return;
                this.selectedAddress.set(undefined);
            });
    }

    setCoordinates(coordinates: Coordinate) {
        this.selectedAddress.set({...this.selectedAddress(), lat: coordinates.latitude, lng: coordinates.longitude});
    }

    setSelectedAddressWithoutLocation(addressWithoutLocation: Omit<AddressDto, 'lat' | 'lng'>) {
        this.selectedAddress.set({...this.selectedAddress(), ...addressWithoutLocation});
    }

    setSelectedAddress(address: AddressDto | undefined) {
        this.selectedAddress.set(address);
    }

    private _isValidAddress(address: AddressDto) {
        return address.fullAddress?.length >= 5 &&
            address.lat &&
            address.lng &&
            address.id != null &&
            address.contactName &&
            address.addressName &&
            address.city &&
            address.phoneNumber &&
            address.email
    }


}
